import { render, staticRenderFns } from "./ModalRoot.vue?vue&type=template&id=a1ec1d4e&scoped=true"
import script from "./ModalRoot.vue?vue&type=script&lang=js"
export * from "./ModalRoot.vue?vue&type=script&lang=js"
import style0 from "./ModalRoot.vue?vue&type=style&index=0&id=a1ec1d4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ec1d4e",
  null
  
)

export default component.exports